/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Dialog_DescriptionInputs */



/**
* | output |
* | --- |
* | "The Eisox services this building does not have yet." |
*
* @param {Go_Further_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_dialog_description = /** @type {((inputs?: Go_Further_Dialog_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Dialog_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Eisox services this building does not have yet.")
	return /** @type {LocalizedString} */ ("Les services Eisox dont ce bâtiment n'est pas encore équipé.")
});